var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fw-jdgl"},[_c('van-nav-bar',{staticStyle:{"background-color":"#CCD5E6"},attrs:{"title":_vm.title,"left-text":"","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),_c('van-tabs',[_c('van-tab',{attrs:{"title":"金豆待审核"}},[_c('Jddsh')],1),_c('van-tab',{attrs:{"title":"金豆审核记录"}},[_c('Jdsh')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }